import React, { memo } from "react";
import { Form, Button } from "react-bootstrap";
import cx from "classnames";

import styles from "./promptField.module.scss";

const PromptInputField = ({ className, value, onChange, onSubmit }) => {
    return (
        <div className={cx(styles.promptInputContainer, className)}>
                <textarea
                    type="text"
                    resize="none"
                    value={value}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          onSubmit();
                        }
                      }}
                    onChange={onChange}
                    placeholder="Let's generate a landing page"
                    className={styles.inputField}
                />
            <div className={styles.promptActions}>
                <Button
                    className={styles.iconButton}
                    variant="info"
                    type="button"
                    aria-label="Send"
                    onClick={onSubmit}
                >
                    <i className="cleverstory-right"></i>
                </Button>
            </div>
        </div>
    );
};

export default memo(PromptInputField);
